// @ts-nocheck
// Vuex module の段階的 TypeScript 化（まずはファイル移管。詳細な型は後続対応）
const state = {
  recentSearch: [],
}

const mutations = {
  setRecentSearch(state, searchWord) {
    state.recentSearch = searchWord
  },
}

const getters = {
  recentSearch(state) {
    return state.recentSearch
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
